import { c as _c } from "react/compiler-runtime";
import { Truck } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useCentPriceFormatter } from '@/hooks/usePriceFormatters';

// Placeholder UI — final layout pending the Figma design for DEV-230488.
// Rendered as an <li> since it sits inside the price list's <ul>. `className` is passed through
// from the surrounding PriceItems list so its mobile/desktop visibility matches its siblings'.
export const FreeShippingBanner = t0 => {
  const $ = _c(12);
  const {
    remainderCentAmount,
    currencyCode,
    className
  } = t0;
  const t = useTranslations();
  const formatPrice = useCentPriceFormatter(currencyCode);
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex items-center gap-1.5 bg-green-100 px-4 py-2 text-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Truck className="size-5 shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== formatPrice || $[4] !== remainderCentAmount || $[5] !== t) {
    t3 = t("miniBasket.freeShippingBanner", {
      amount: formatPrice(remainderCentAmount)
    });
    $[3] = formatPrice;
    $[4] = remainderCentAmount;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span>{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <li className={t1}>{t2}{t4}</li>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};